// extracted by mini-css-extract-plugin
export var cardIcon = "_8h-4";
export var checkboxCard = "_8h-0";
export var checkboxCardSelected = "_8h-3";
export var disabled = "_8h-1";
export var outerBorder = "_8h-2";
export var spacerMedium = "_8h-7";
export var spacerSmall = "_8h-6";
export var spacerXsmall = "_8h-5";